<template>
    <div class="companyBox">
        <navigation></navigation>
        <div class="homeBG">
        </div>
        <div class="productList">
            <div 
                :class="['filter-item', { active: currentRoute === '/lvdai' }]"
                @click="navigateToLvdai"
                @mouseenter="hoverFilterItem('lvdai')"
                @mouseleave="hoverFilterItem(null)"
            >
                环保滤袋
            </div>
            <div 
                :class="['filter-item', { active: currentRoute === '/lvtong' }]"
                @click="navigateToLvtong"
                @mouseenter="hoverFilterItem('lvtong')"
                @mouseleave="hoverFilterItem(null)"
            >
                环保滤筒
            </div>
        </div>
        <div class="companyInfo">

            <div class="productBox" v-for="(item, index) in filterMediaList" :key="index">
                <div class="img">
                    <img :src="baseApi + item.productImages" alt="">
                </div>
                <div class="textBox">
                    <strong style="font-size:30px">{{ item.productName }}</strong>
                    <br />
                    <span v-html="formatProductIntro(item.productIntro)"></span>
                </div>
            </div>
        </div>
        <dibu></dibu>
    </div>
</template>

<script>
import navigation from '@/views/navigation.vue'
import dibu from '@/views/dibu.vue';
import axios from 'axios';
export default {
    name: 'CompanyProfile',
    data() {
        return {
            filterMediaList: [],
            baseApi: "https://3521hb.com/api",
            currentRoute: '/lvdai'
        }
    },
    watch: {
        '$route.path'(newPath) {
            this.currentRoute = newPath;
        }
    },
    mounted() {
        this.getCompanyInfo();
        this.currentRoute = this.$route.path;
    },
    components: {
        navigation,
        dibu
    },
    methods: {
        async getCompanyInfo() {
            let res = await axios.get('https://3521hb.com/api/product/selectPage?category=滤料&pageNum=1&pageSize=100')
            console.log(res);

            if (res.data.code == 200) {
                this.filterMediaList = res.data.data.list;
                console.log(this.filterMediaList);

            }
        },
        formatProductIntro(text) {
            if (!text) return '';
            // 基本的XSS防护：只允许换行符替换
            return text.replace(/\n/g, '<br />');
        },
        navigateToLvdai() {
            if (this.$route.path !== '/lvdai') {
                this.$router.push('/lvdai');
            }
        },
        navigateToLvtong() {
            if (this.$route.path !== '/lvtong') {
                this.$router.push('/lvtong');
            }
        },


    }
}
</script>
<style lang="scss" scoped>
.companyBox {
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;

    .homeBG {
        width: 100%;
        height: 800px;
        background-image: url('../img/chanpinBG3.webp');
        background-size: 100% 100%;
        
        @media (max-width: 768px) {
            height: 400px;
        }
        
        @media (max-width: 480px) {
            height: 250px;
        }
    }
    
    .productList {
        width: 100%;
        height: 70px;
        display: flex;
        padding-left: 200px;
        box-sizing: border-box;
        align-items: center;
        font-size: 32px;
        color: black;
        border-bottom: 1px solid #e0e0e0;
        
        @media (max-width: 1200px) {
            padding-left: 100px;
        }
        
        @media (max-width: 992px) {
            padding-left: 50px;
            font-size: 28px;
        }
        
        @media (max-width: 768px) {
            height: 60px;
            padding-left: 20px;
            font-size: 24px;
        }
        
        @media (max-width: 480px) {
            height: 50px;
            font-size: 20px;
            padding-left: 15px;
        }
        
        .filter-item {
            margin-right: 50px;
            cursor: pointer;
            padding: 10px 20px;
            border-radius: 8px;
            transition: all 0.3s ease;
            position: relative;
        
            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 50%;
                width: 0;
                height: 2px;
                background: #ff1818;
                transition: all 0.3s ease;
                transform: translateX(-50%);
            }
            
            &:hover::after {
                width: 80%;
            }
            
            &.active::after {
                width: 80%;
                background: #ff1818;
            }
            
            @media (max-width: 992px) {
                margin-right: 30px;
                padding: 8px 16px;
            }
            
            @media (max-width: 768px) {
                margin-right: 20px;
                padding: 6px 12px;
                font-size: 18px;
            }
            
            @media (max-width: 480px) {
                margin-right: 15px;
                padding: 5px 10px;
                font-size: 16px;
            }
        }
    }

    .companyInfo {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        padding: 40px 100px;
        box-sizing: border-box;
        justify-content: space-between;

        @media (max-width: 1400px) {
            padding: 40px 50px;
        }
        
        @media (max-width: 1200px) {
            padding: 40px 30px;
        }
        
        @media (max-width: 768px) {
            padding: 30px 20px;
        }
        
        @media (max-width: 480px) {
            padding: 20px 15px;
        }

        .productBox {
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;
            width: 48%;
            box-sizing: border-box;

            @media (max-width: 1200px) {
                width: 47%;
            }
            
            @media (max-width: 768px) {
                width: 100%;
                flex-direction: column;
                margin-bottom: 25px;
            }
        }

        .img {
            display: flex;
            width: 400px;
            height: 270px;
            padding-top: 10px;
            box-sizing: border-box;
            flex-shrink: 0;

            @media (max-width: 1400px) {
                width: 350px;
                height: 240px;
            }
            
            @media (max-width: 1200px) {
                width: 320px;
                height: 220px;
            }
            
            @media (max-width: 992px) {
                width: 280px;
                height: 190px;
            }
            
            @media (max-width: 768px) {
                width: 100%;
                height: 200px;
                padding-top: 0;
                justify-content: center;
            }
            
            @media (max-width: 480px) {
                height: 160px;
            }
        }

        .img img {
            border-radius: 20px;
            margin: 0 auto;
            height: 100%;
            object-fit: contain;
            max-width: 100%;
        }

        .textBox {
            display: flex;
            align-items: center;
            flex-direction: column;
            width: 410px;
            height: 100%;
            font-size: 20px;
            margin-left: 30px;
            box-sizing: border-box;

            @media (max-width: 1400px) {
                width: 380px;
                font-size: 18px;
                margin-left: 25px;
            }
            
            @media (max-width: 1200px) {
                width: 350px;
                font-size: 17px;
                margin-left: 20px;
            }
            
            @media (max-width: 992px) {
                width: 300px;
                font-size: 16px;
                margin-left: 15px;
            }
            
            @media (max-width: 768px) {
                width: 100%;
                font-size: 16px;
                margin-left: 0;
                margin-top: 15px;
                align-items: flex-start;
            }
            
            @media (max-width: 480px) {
                font-size: 14px;
                margin-top: 10px;
            }
        }
    }
}
</style>